var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEventSlots(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 87.211,
    height: 86.492,
    viewBox: "0 0 87.211 86.492",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1653",
    "data-name": "Rectangle 1653",
    width: 87.211,
    height: 86.492,
    fill: "#575757"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4206",
    "data-name": "Group 4206",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3704",
    "data-name": "Group 3704",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14152",
    "data-name": "Path 14152",
    d: "M15.6,45.877c-2.091-1.062-2.5-1.856-2.083-4.058a8.621,8.621,0,0,1,8.593-6.735,65.11,65.11,0,0,1,7.767.177,8.207,8.207,0,0,1,7.268,7.9c-.026,1.4-.961,2.167-2.228,2.72Z",
    transform: "translate(18.358 40.613)",
    fill: "#575757"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14153",
    "data-name": "Path 14153",
    d: "M2.2,45.879C.093,44.694-.322,43.785.209,41.527a8.727,8.727,0,0,1,8.6-6.443,63.5,63.5,0,0,1,7.672.175,8.149,8.149,0,0,1,7.3,7.942c-.028,1.414-.978,2.161-2.271,2.679Z",
    transform: "translate(0 40.612)",
    fill: "#575757"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14154",
    "data-name": "Path 14154",
    d: "M29.023,45.877c-2.045-.939-2.549-1.843-2.188-3.939a8.649,8.649,0,0,1,8.59-6.851,63.092,63.092,0,0,1,7.857.186,8.2,8.2,0,0,1,7.23,7.847c-.012,1.388-.935,2.174-2.174,2.759Z",
    transform: "translate(36.696 40.613)",
    fill: "#575757"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14155",
    "data-name": "Path 14155",
    d: "M55.793,22.285c-.318,2.69-.631,5.34-.947,7.991-.558,4.725-1.1,9.455-1.687,14.178-.225,1.818-1.687,2.815-4.2,2.983-.271.017-.543,0-.793,0-2.572-7.38-7.181-10.888-14.11-10.787A13.669,13.669,0,0,0,20.706,47.36c-2.776.419-4.786-.9-5.085-3.38q-1.289-10.653-2.546-21.31c-.012-.108-.038-.216-.078-.423-.736,0-1.471.015-2.2,0C8.383,22.186,6.687,20.669,6.7,18.6s1.751-3.568,4.16-3.568q23.585-.006,47.17,0c2.347,0,4.07,1.511,4.1,3.54.031,2.044-1.618,3.577-3.963,3.674-.494.019-.992,0-1.485.006-.273,0-.543.022-.887.037",
    transform: "translate(9.2 17.406)",
    fill: "#575757"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14156",
    "data-name": "Path 14156",
    d: "M27.431,19.179q-6.126,0-12.252,0c-2.423,0-3.571-1.112-3.455-3.316.209-3.9,3.934-7.365,8.246-7.447q7.564-.142,15.128,0c4.6.095,8.407,3.944,8.256,8.129-.057,1.576-1.353,2.625-3.3,2.629-4.207.011-8.415,0-12.622,0",
    transform: "translate(16.087 9.663)",
    fill: "#575757"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14157",
    "data-name": "Path 14157",
    d: "M22.971,14.392c-4.364,0-7.914-3.21-7.933-7.169S18.631-.019,23.016,0c4.34.017,7.909,3.285,7.885,7.223-.019,3.963-3.569,7.169-7.93,7.169",
    transform: "translate(20.647 -0.001)",
    fill: "#575757"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14158",
    "data-name": "Path 14158",
    d: "M29.243,33.749c.014-3.013,2.653-5.379,5.978-5.358a5.679,5.679,0,0,1,5.9,5.373c.012,2.957-2.71,5.438-5.961,5.429a5.681,5.681,0,0,1-5.913-5.444",
    transform: "translate(40.15 32.893)",
    fill: "#575757"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14159",
    "data-name": "Path 14159",
    d: "M21.778,28.391a5.675,5.675,0,0,1,5.982,5.371,5.723,5.723,0,0,1-5.949,5.427,5.735,5.735,0,0,1-5.935-5.356,5.655,5.655,0,0,1,5.9-5.442",
    transform: "translate(21.797 32.893)",
    fill: "#575757"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14160",
    "data-name": "Path 14160",
    d: "M8.493,28.39a5.623,5.623,0,0,1,5.892,5.435,5.684,5.684,0,0,1-5.9,5.366,5.754,5.754,0,0,1-5.968-5.42,5.693,5.693,0,0,1,5.98-5.381",
    transform: "translate(3.45 32.892)",
    fill: "#575757"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventSlots);
export default __webpack_public_path__ + "static/media/EventSlots.83d62085c7ab6ef3ca971d84b182764f.svg";
export { ForwardRef as ReactComponent };